import { Pipe, PipeTransform } from '@angular/core';

const BASE64_KEY_CHAR_CLASS = '[A-Za-z0-9+/]';
const BASE64_KEY_TOKEN_BODY_PATTERN =
  `(?:(?:${BASE64_KEY_CHAR_CLASS}{4})){3,}(?:${BASE64_KEY_CHAR_CLASS}{2}==|${BASE64_KEY_CHAR_CLASS}{3}=|${BASE64_KEY_CHAR_CLASS}{4})`;
const BASE64_KEY_TOKEN_EXACT = new RegExp(`^${BASE64_KEY_TOKEN_BODY_PATTERN}$`);

function isValidBase64KeyToken(token: string): boolean {
  return !!token && BASE64_KEY_TOKEN_EXACT.test(token);
}

/**
 * Strips legacy EntityKey markup from AI answers. Display links used to be resolved from store
 * user context, which is no longer populated (orchestration moved server-side).
 */
@Pipe({ name: 'entityKeyRef', })
export class EntityKeyRefPipe implements PipeTransform {

  private static readonly COLON_PATTERN = /\(EntityKey:\s*entityKey(\d+)\)/gi;
  private static readonly SINGLE_PATTERN = /\(EntityKey(\d+)\)/gi;
  private static readonly MULTIPLE_PATTERN = /\(EntityKey(\d+),\s*EntityKey(\d+)\)/gi;
  private static readonly BARE_COLON_PATTERN = /\bEntityKey:\s*entityKey(\d+)\b/gi;
  private static readonly BARE_PATTERN = /\bEntityKey(\d+)\b/gi;
  private static readonly SPACED_COLON_PATTERN = /\(Entity Key:\s*(?:entityKey|k)?(\d+)\)/gi;

  private static readonly BARE_ENTITY_KEY_B64_PATTERN = new RegExp(
    String.raw`(?<![A-Za-z0-9+/])EntityKey:\s*(${BASE64_KEY_TOKEN_BODY_PATTERN})(?![A-Za-z0-9+/])`,
    'gi',
  );

  transform(value?: string | null): string {
    if (!value) return '';

    return this.replaceEntityKeyPatterns(value, () => '');
  }

  private replaceEntityKeyPatterns(
    value: string,
    transform: (entityKey: string, entityType?: string) => string
  ): string {
    const composeKey = (keyNumber: string) => transform(`EntityKey${keyNumber}`);
    const replaceSingleKey = (match: string, keyNumber: string) => composeKey(keyNumber);
    const replaceMultipleKey = (match: string, key1: string, key2: string) => `${composeKey(key1)}, ${composeKey(key2)}`;
    const replaceBase64Key = (match: string, token: string) =>
      isValidBase64KeyToken(token) ? transform(token) : match;

    value = value.replace(EntityKeyRefPipe.MULTIPLE_PATTERN, replaceMultipleKey);
    value = value.replace(EntityKeyRefPipe.SPACED_COLON_PATTERN, replaceSingleKey);
    value = value.replace(EntityKeyRefPipe.COLON_PATTERN, replaceSingleKey);
    value = value.replace(EntityKeyRefPipe.SINGLE_PATTERN, replaceSingleKey);
    value = value.replace(EntityKeyRefPipe.BARE_COLON_PATTERN, replaceSingleKey);
    value = value.replace(EntityKeyRefPipe.BARE_PATTERN, replaceSingleKey);
    value = value.replace(EntityKeyRefPipe.BARE_ENTITY_KEY_B64_PATTERN, replaceBase64Key);
    return value;
  }
}
